module.exports = __webpack_public_path__ + "static/media/anglo-american.34ccfde4.png";